import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Sparkles } from "lucide-react";
import api from "./api";

const REVIEW_MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export default function Clients() {
  const [q, setQ] = useState("");
  const [month, setMonth] = useState("");
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/crm/clients", { params: { q: q || undefined, review_month: month || undefined } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); })
      .finally(() => setLoading(false));
  }, [q, month]);

  return (
    <div data-testid="clients-page">
      <header className="mb-8">
        <div className="text-[11px] tracking-[0.35em] uppercase" style={{ color: "var(--crm-accent)" }}>
          Book of business
        </div>
        <h1 className="text-3xl font-light mt-1" style={{ color: "var(--crm-text)" }}>
          Current Clients
        </h1>
        <p className="text-sm mt-2" style={{ color: "var(--crm-text-muted)" }}>
          {total.toLocaleString()} active clients on the roster.
        </p>
      </header>

      <div className="crm-glass rounded-2xl p-4 mb-5 flex flex-wrap gap-3 items-center">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--crm-text-subtle)" }} />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search clients…"
            data-testid="clients-search"
            className="w-full pl-9 pr-3 py-2 rounded-lg text-sm focus:outline-none crm-pane"
            style={{ background: "var(--crm-bg-elev)", color: "var(--crm-text)" }}
          />
        </div>
        <select
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          data-testid="clients-month"
          className="px-3 py-2 rounded-lg text-sm crm-pane"
          style={{ background: "var(--crm-bg-elev)", color: "var(--crm-text)" }}
        >
          <option value="">All review months</option>
          {REVIEW_MONTHS.map((m) => (<option key={m}>{m}</option>))}
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {loading ? (
          <div className="col-span-full text-center py-16" style={{ color: "var(--crm-text-muted)" }}>Loading…</div>
        ) : items.length === 0 ? (
          <div className="col-span-full text-center py-16" style={{ color: "var(--crm-text-muted)" }}>No clients match your filters.</div>
        ) : (
          items.map((c) => (
            <Link
              key={c.id}
              to={`/crm/contacts/${c.contact_id}`}
              className="crm-glass rounded-2xl p-5 transition hover:-translate-y-0.5 hover:shadow-lg"
              style={{ color: "var(--crm-text)" }}
              data-testid={`client-${c.contact_id}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium text-black"
                  style={{ background: "linear-gradient(180deg,#f4d47b,#d4a53a 55%,#b78a2f)" }}>
                  {(c.first_name?.[0] || c.name?.[0] || "?").toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[15px] truncate">{c.name}</div>
                  <div className="text-xs truncate" style={{ color: "var(--crm-text-muted)" }}>{c.email || c.phone || "—"}</div>
                </div>
                {c.has_profile && (
                  <span className="text-[10px] px-2 py-0.5 rounded-full" style={{ background: "var(--crm-accent-soft)", color: "var(--crm-accent)" }}>
                    <Sparkles size={10} className="inline -mt-0.5 mr-0.5" /> Profile
                  </span>
                )}
              </div>
              <div className="grid grid-cols-2 gap-3 text-xs" style={{ color: "var(--crm-text-muted)" }}>
                <div>
                  <div className="uppercase tracking-widest text-[9px] opacity-70">Stage</div>
                  <div className="mt-0.5" style={{ color: "var(--crm-text)" }}>{c.stage || "—"}</div>
                </div>
                <div>
                  <div className="uppercase tracking-widest text-[9px] opacity-70">Source</div>
                  <div className="mt-0.5" style={{ color: "var(--crm-text)" }}>{c.lead_source || "—"}</div>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
